import { message } from "antd";
import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";
import actions from "../actions/actions";
import bindTagToMeter from "../../requests/bindTagToMeter";
import getAddressMeters from "./getAddressMeters";
import getAddresses from "./getAddresses";
import moment from "moment";

const saveMeter = (meter) => async (dispatch) => {
	try {
		dispatch({ type: actions.ITEM_LOADING });
		const response = await client.post(
			"/Meter/add_meter",
			{
				...meter,
				CommissionningDate: meter.CommissionningDate
					? moment(meter.CommissionningDate.format('YYYY-MM-DD[T00:00:00]'))
							.utc()
							.format()
					: null,
				DecommissionningDate: meter.DecommissionningDate
					? moment(meter.DecommissionningDate.format('YYYY-MM-DD[T00:00:00]'))
							.utc()
							.format()
					: null,
				Coef: meter.Coef || 1,
			},
			{
				headers: authHeader(),
			}
		);
		if (meter.Tag) {
			await bindTagToMeter(response.data.id, meter.Tag);
		}
		message.success("Счётчик создан");
		dispatch(getAddresses({}));
		dispatch(getAddressMeters(meter.HouseId));
	} catch (e) {
		message.error("При создании счётчика произошла ошибка");
		throw e;
	}
};
export default saveMeter;
